// extracted by mini-css-extract-plugin
export default {"container":"ValueListInput_container__q5nZj","note":"ValueListInput_note__TU9S9"};